import { adminAuditLogConstants } from "_constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import { produce } from "immer";

let initState = {
  sections: [],
  logs: [],
};

export function auditLog(state = { ...initState }, action) {
  const { payload, type } = action;

  switch (type) {
    case adminAuditLogConstants.GET_AUDIT_LOGS_SUCCESS:
      return produce(state, (draft) => {
        draft["logs"] = [...payload];
      });

    case adminAuditLogConstants.SEARCH_BY_USERNAME_SUCCESS:
      return produce(state, (draft) => {
        draft["logs"] = [...payload];
      });

    case adminAuditLogConstants.CLEAR_AUDIT_LOGS:
      return {
        ...initState,
      };

    case REHYDRATE: {
      if (payload && payload.admin && payload.admin.auditLog) {
        return { ...payload.admin.auditLog };
      } else {
        return { ...initState };
      }
    }

    default:
      return state;
  }
}
